import clsx from "clsx";

type Option = { label: string; value: string; count?: number };

export default function Segmented({ value, options, onChange, label }: { value: string; options: Option[]; onChange: (value: string) => void; label: string }) {
  return (
    <div role="tablist" aria-label={label} className="inline-flex rounded-xl border border-edge bg-overlay p-1">
      {options.map((option) => {
        const on = option.value === value;
        return (
          <button
            key={option.value}
            role="tab"
            type="button"
            aria-selected={on}
            onClick={() => onChange(option.value)}
            className={clsx(
              "flex items-center gap-2 rounded-lg px-3.5 py-1.5 font-[Gilroy-Medium] text-[13px] transition-all duration-300",
              on ? "bg-surface text-heading-color shadow-card" : "text-light-gray hover:text-heading-color",
            )}
          >
            {option.label}
            {option.count != null ? (
              <span className={clsx("rounded-full px-1.5 text-[11px] tabular-nums", on ? "bg-accent text-white" : "bg-overlay-mid text-label-muted")}>{option.count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
